import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance } from 'vue';
//types
import type { TravelInsuranceTraveller } from '../../../types.ts';
//helpers
import { DATE_TIME_FORMATS, formatWithLocale, parseISO } from '@white-label-helper/date-utilities';

interface Props {
  travelInsuranceTraveller?: TravelInsuranceTraveller;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'travel-insurance-additional-traveller-card',
  props: {
    travelInsuranceTraveller: { default: () => ({} as TravelInsuranceTraveller) }
  },
  setup(__props: any) {

const props = __props as { travelInsuranceTraveller: TravelInsuranceTraveller };

// core
const instance = getCurrentInstance();
const proxy = instance?.proxy as {
  $i18n: {
    locale: string;
  };
  $t: (key: string) => string;
} | undefined;
const i18n = proxy?.$i18n;



function formattedDate(date: string): string {
  if (!i18n) return '';

  return date
    ? formatWithLocale(
        parseISO(date),
        DATE_TIME_FORMATS.day_month_full_year_slash_spaced,
        i18n.locale
      ) : '';
}

return { __sfc: true,instance, proxy, i18n, props, formattedDate }
}

})